module.exports = __webpack_public_path__ + "img/1525789215.1a9c9bdc.jpg";